import React from 'react';
import { ImageIcon, Loader2 } from 'lucide-react';

interface ImageMessageBubbleProps {
  imageUrl: string | null;
  caption?: string | null;
  processingStatus?: 'pending' | 'processing' | 'completed' | 'error' | null;
  timestamp?: string;
}

export const ImageMessageBubble: React.FC<ImageMessageBubbleProps> = ({ 
  imageUrl, 
  caption, 
  processingStatus,
  timestamp 
}) => {
  return (
    <div className="flex justify-end mb-2">
      <div className="bg-[#DCF8C6] rounded-lg overflow-hidden max-w-[85%] shadow-sm">
        {imageUrl ? (
          <div className="relative">
            <img 
              src={imageUrl} 
              alt="Preview" 
              className="w-full max-w-[250px] h-auto rounded-t-lg"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><rect fill="%23ddd"/></svg>';
              }}
            />
            {processingStatus === 'processing' && (
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                <Loader2 className="h-6 w-6 text-white animate-spin" />
              </div>
            )}
          </div>
        ) : (
          <div className="w-[250px] h-[150px] bg-gray-200 flex items-center justify-center">
            <ImageIcon className="h-12 w-12 text-gray-400" />
          </div>
        )}
        
        {caption && caption.trim() && (
          <div className="px-3 py-2">
            <p className="text-sm text-gray-800 whitespace-pre-wrap break-words">
              {caption}
            </p>
          </div>
        )}
        
        <div className="flex justify-end items-center gap-1 px-3 pb-2">
          <span className="text-[10px] text-gray-600">
            {timestamp || new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
};
